import { defineNuxtPlugin, useRuntimeConfig } from "nuxt/app";
import { appLogger } from "@/services/AppLogger";
import { customAxios } from "@/services/httpRequestServer";
import { useUserProfileStore } from "@/store/userProfileStore";

export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig();
  
  // Initialize axios baseURL with runtime config
  customAxios.defaults.baseURL = runtimeConfig.public.baseUrl as string;

  // Request interceptor - can safely use composables here
  customAxios.interceptors.request.use(request => {
    const userProfile = useUserProfileStore();

    const isApiUrl = request.url?.startsWith(process.env.VUE_APP_API_PREFIX ?? "");
    // add auth header with jwt if account is logged in and request is to the api url
    if (isApiUrl && userProfile.accessToken) {
      request.headers.Authorization = `Bearer ${userProfile.accessToken}`;
    }

    return request;
  });

  // Response interceptor
  customAxios.interceptors.response.use(undefined, function (error) {
    if (error) {
      if (error.response?.status === 401) {
        let loginUrl = error.response.data?.loginUrl;
        if (loginUrl) {
          loginUrl = loginUrl + "?returnUrl=" + window.location.pathname + window.location.search;
          window.location.href = loginUrl;
        }
        else {
          throw new Error("Unauthorized request");
        }
      } 
      else {
        appLogger.logError(error, {
            message: error.message,
            status: error.response?.status,
            statusText: error.response?.statusText,
            url: error.config.url,
        });
        throw error;
      }
    }
  });
});
